import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { USER_INPUT_DEBOUNCE_TIME } from '../../../../../aumico-lib-core-fe/src/lib';

@UntilDestroy()
@Component({
    selector: 'ham-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
    searchForm: FormGroup;
    filteredItemKey: string = '';

    @Input() searchButtonLabel: string;
    @Input() placeholder: string;
    @Input() hasFilterButton: boolean = true;
    @Input() value: string;
    @Input() autoEmit: boolean = false; // Optional input to enable auto-emit with debounce
    @Output() filter = new EventEmitter<string>();
    constructor(private readonly fb: FormBuilder) {}

    ngOnInit(): void {
        this.searchForm = this.fb.group({
            searchTerm: [this.value || ''],
        });

        // Set up auto-emit with debounce if enabled
        if (this.autoEmit) {
            this.searchForm
                .get('searchTerm')
                ?.valueChanges.pipe(
                    debounceTime(USER_INPUT_DEBOUNCE_TIME),
                    distinctUntilChanged(), // Only emit when value actually changes
                    untilDestroyed(this),
                )
                .subscribe((value: string) => {
                    this.filter.emit(value);
                });
        }
    }

    onSearchEnter(): void {
        if (!this.hasFilterButton) {
            const value = this.searchForm.get('searchTerm').value;
            this.filter.emit(value);
        }
    }

    filterItems(): void {
        const filterValue = this.searchForm.get('searchTerm').value;
        this.filter.emit(filterValue);
    }

    resetFilter(): void {
        this.filter.emit(null);
    }
}
